import { render, staticRenderFns } from "./MainIcoachPageTemplate.vue?vue&type=template&id=aaed62a8&"
import script from "./MainIcoachPageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MainIcoachPageTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports